import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { IAnswerAll } from '../models';

export function useChatFlowAnswerAll() {
  const status = useAppSelector(state => state.aiAgentReducer.resultKey);
  const agentId = useAppSelector(state => state.aiAgentReducer.body?.id);
  const [query] = useQueryParams({
    page: withDefault(NumberParam, 1),
    endDate: StringParam,
    startDate: StringParam,
    text: StringParam
  });

  const body = {
    status,
    ...query,
    page: query?.page || '1',
    size: '10'
  };

  return useQuery<Pagination<IAnswerAll>>({
    queryKey: ['chat-flow-answer', agentId, body],
    queryFn: async () => {
      const res = await $api.post(`/v1/chat-flow/answer/all/${agentId}`, body);

      return res?.data?.data;
    },
    enabled: !!agentId && agentId !== 'new'
  });
}
